<form [formGroup]="compraForm" class="forms">
    <div class="row">
      <div class="row info-container white-box">
        <h2>Levantamento das compras - Último trimestre</h2>
        <div class="form-group">
          <span class="icon calendario-cash"></span>
          <div class="inputs">
            <label for="comprasAUmMes">Há 1 mês</label>
            <input
              class="form-control"
              type="text"
              placeholder="R$ 0.000,00"
              name="comprasAUmMes"
              formControlName="comprasAUmMes"
              maxlength="17"
              minlength="3"
              appShowErrorMessages
              mask-money
              inputmode="numeric"
              [prefix]="'R$'"
              appOnlyNumberRestrictive>
          </div>
        </div>
        <div class="form-group">
          <span class="icon vazio"></span>
          <div class="inputs">
            <label for="comprasADoisMeses">Há 2 meses</label>
            <input
              class="form-control"
              type="text"
              placeholder="R$ 0.000,00"
              name="comprasADoisMeses"
              formControlName="comprasADoisMeses"
              maxlength="17"
              minlength="3"
              appShowErrorMessages
              mask-money
              inputmode="numeric"
              [prefix]="'R$'"
              appOnlyNumberRestrictive>
          </div>
        </div>
        <div class="form-group">
          <span class="icon vazio"></span>
          <div class="inputs">
            <label for="comprasATresMeses">Há 3 meses</label>
            <input
              class="form-control"
              type="text"
              placeholder="R$ 0.000,00"
              name="comprasATresMeses"
              formControlName="comprasATresMeses"
              maxlength="17"
              minlength="3"
              appShowErrorMessages
              mask-money
              inputmode="numeric"
              [prefix]="'R$'"
              appOnlyNumberRestrictive>
          </div>
        </div>
        <div class="form-group">
          <span class="icon vazio"></span>
          <div class="inputs">
            <label for="percentualComprasAVista">Porcentagem de compras a vista</label>
            <div class="input-group">
              <input
                class="form-control"
                type="text"
                placeholder="100 %"
                name="percentualComprasAVista"
                formControlName="percentualComprasAVista"
                maxlength="3"
                minlength="1"
                appShowErrorMessages
                inputmode="numeric"
                appOnlyNumberRestrictive>
                <span class="input-group-addon">%</span>
            </div>
          </div>

        </div>
      </div>
    </div>
  </form>

  <app-botao-navegacao
  (previous)="onClickPrevious()"
  (next)="onClickNext()"
  [previousShow]="true"
  [nextShow]="true"
  [nextEnabled]="compraForm.valid">
  </app-botao-navegacao>
